// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  OfferingPackagePageOfferingPackageFragmentDoc,
  OfferingPackagePageCoachPackageFragmentDoc,
} from './OfferingPackagePage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ApplicantPlanPageOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  name: string;
  description: string;
  imageLink?: string | null;
  deliveryFormat?: Types.CoachingDeliveryFormat | null;
  coachingDescription?: string | null;
  deliverables?: Array<string> | null;
  isUniversalPackage: boolean;
  version: number;
  visibility: Types.PackageVisibility;
  slug?: string | null;
  subTitle?: string | null;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
  category?: {
    __typename?: 'Category';
    id: string;
    slug: string;
    goal: Types.GoalName;
    name: string;
    averageReviewRate: number;
    outcomes?: Array<
      | {
          __typename?: 'CareerOutcomeSummary';
          number: number;
          companies: Array<{
            __typename?: 'Company';
            id?: string | null;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'SchoolOutcomeSummary';
          number: number;
          schools: Array<{
            __typename?: 'School';
            id: string;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'TestOutcomeSummary';
          scoreRange?: string | null;
          number: number;
          category: { __typename?: 'Category'; id: string; name: string };
        }
    > | null;
  } | null;
  packageTerm?: {
    __typename?: 'PackageTerm';
    refundPolicy: Types.RefundPolicy;
    additionalInformation?: string | null;
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    newExperience?: boolean | null;
    visibility: Types.CoachVisibility;
    slug: string;
    reviewTotal: number;
    averageReviewRate: number;
    professionalCoach: boolean;
    openToInternational: boolean;
    createdAt: number;
    lelandPlusContributor: boolean;
    hourlyRate?: number | null;
    tier: Types.SkuTier;
    averageKnowledgeReviewRate: number;
    averageValueReviewRate: number;
    averageResponsivenessReviewRate: number;
    averageSupportivenessReviewRate: number;
    couldScheduleIntro?: boolean | null;
    everHadCoachingSessionWithCoach?: boolean | null;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      headline?: string | null;
      qualifications?: string | null;
      testScore?: number | null;
      displayTestScore?: boolean | null;
      experienceLevel?: number | null;
      customersCoached?: number | null;
      id: string;
      category: {
        __typename?: 'Category';
        id: string;
        name: string;
        slug: string;
        goal: Types.GoalName;
        subCategoryTitle?: string | null;
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          id: string;
          name: string;
        }> | null;
      };
      coachingFocusList?: Array<{
        __typename?: 'CoachingFocus';
        id: string;
        name: string;
        slug: string;
      }> | null;
    }> | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      blockedByCoach: boolean;
      newExperience: boolean;
      paidTimeInMinute?: number | null;
      review?: { __typename?: 'Review'; id: string } | null;
      customerSubscription?: {
        __typename?: 'CustomerSubscription';
        id: string;
        sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      } | null;
    } | null;
    introVideo?: {
      __typename?: 'VideoLink';
      duration: string;
      thumbnailLink: string;
      youtubeId: string;
    } | null;
    educationExperiences?: Array<{
      __typename?: 'Education';
      isFeatured?: boolean | null;
      school: {
        __typename?: 'School';
        id: string;
        name: string;
        logoLink?: string | null;
      };
    }> | null;
    schoolAdmissionInfoList?: Array<{
      __typename?: 'SchoolAdmissionInfo';
      status?: Types.SchoolAdmissionStatus | null;
      school: {
        __typename?: 'School';
        id: string;
        name: string;
        logoLink?: string | null;
      };
    }> | null;
    professionalExperiences?: Array<{
      __typename?: 'ProfessionalExperience';
      isFeatured?: boolean | null;
      company: {
        __typename?: 'Company';
        id?: string | null;
        name: string;
        domain?: string | null;
        logoLink?: string | null;
      };
      endAt?: { __typename?: 'MonthYear'; year: number } | null;
    }> | null;
    companiesAdmitted?: Array<{
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    }> | null;
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      availableTime: number;
      hasUnlimitedPackage: boolean;
      cycles?: Array<{
        __typename?: 'SubscriptionCycle';
        timeInMinute: number;
        start?: number | null;
        end?: number | null;
      }> | null;
    } | null;
    mostRecentOrder?: {
      __typename?: 'Order';
      id: string;
      hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
    } | null;
    availability?: {
      __typename?: 'CoachAvailability';
      nextAvailableAt?: number | null;
      defaultAvailability?: {
        __typename?: 'DefaultAvailability';
        totalInMinute: number;
      } | null;
    } | null;
  };
  subCategories?: Array<{ __typename?: 'SubCategory'; id: string }> | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    tier?: Types.SkuTier | null;
    description?: string | null;
    numberPurchased: number;
    freeLelandPlusPeriod?: {
      __typename?: 'TimePeriod';
      amount: number;
      unit: Types.TimeUnit;
    } | null;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
};

export type ApplicantPlanPageOfferingPackageBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  coach: Types.Scalars['String']['input'];
  categoryUrn: Types.Scalars['CategoryUrn']['input'];
  visibleTierOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  tier?: Types.InputMaybe<Types.SkuTier>;
}>;

export type ApplicantPlanPageOfferingPackageBySlugQuery = {
  __typename?: 'Query';
  offeringPackageBySlug?: {
    __typename?: 'OfferingPackage';
    id: string;
    name: string;
    description: string;
    imageLink?: string | null;
    deliveryFormat?: Types.CoachingDeliveryFormat | null;
    coachingDescription?: string | null;
    deliverables?: Array<string> | null;
    isUniversalPackage: boolean;
    version: number;
    visibility: Types.PackageVisibility;
    slug?: string | null;
    subTitle?: string | null;
    coachingFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
    }> | null;
    category?: {
      __typename?: 'Category';
      id: string;
      slug: string;
      goal: Types.GoalName;
      name: string;
      averageReviewRate: number;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            number: number;
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            number: number;
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'TestOutcomeSummary';
            scoreRange?: string | null;
            number: number;
            category: { __typename?: 'Category'; id: string; name: string };
          }
      > | null;
    } | null;
    packageTerm?: {
      __typename?: 'PackageTerm';
      refundPolicy: Types.RefundPolicy;
      additionalInformation?: string | null;
    } | null;
    coach: {
      __typename?: 'Coach';
      id: string;
      newExperience?: boolean | null;
      visibility: Types.CoachVisibility;
      slug: string;
      reviewTotal: number;
      averageReviewRate: number;
      professionalCoach: boolean;
      openToInternational: boolean;
      createdAt: number;
      lelandPlusContributor: boolean;
      hourlyRate?: number | null;
      tier: Types.SkuTier;
      averageKnowledgeReviewRate: number;
      averageValueReviewRate: number;
      averageResponsivenessReviewRate: number;
      averageSupportivenessReviewRate: number;
      couldScheduleIntro?: boolean | null;
      everHadCoachingSessionWithCoach?: boolean | null;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        qualifications?: string | null;
        testScore?: number | null;
        displayTestScore?: boolean | null;
        experienceLevel?: number | null;
        customersCoached?: number | null;
        id: string;
        category: {
          __typename?: 'Category';
          id: string;
          name: string;
          slug: string;
          goal: Types.GoalName;
          subCategoryTitle?: string | null;
          subCategoryList?: Array<{
            __typename?: 'SubCategory';
            id: string;
            name: string;
          }> | null;
        };
        coachingFocusList?: Array<{
          __typename?: 'CoachingFocus';
          id: string;
          name: string;
          slug: string;
        }> | null;
      }> | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        blockedByCoach: boolean;
        newExperience: boolean;
        paidTimeInMinute?: number | null;
        review?: { __typename?: 'Review'; id: string } | null;
        customerSubscription?: {
          __typename?: 'CustomerSubscription';
          id: string;
          sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
        } | null;
      } | null;
      introVideo?: {
        __typename?: 'VideoLink';
        duration: string;
        thumbnailLink: string;
        youtubeId: string;
      } | null;
      educationExperiences?: Array<{
        __typename?: 'Education';
        isFeatured?: boolean | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      schoolAdmissionInfoList?: Array<{
        __typename?: 'SchoolAdmissionInfo';
        status?: Types.SchoolAdmissionStatus | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      professionalExperiences?: Array<{
        __typename?: 'ProfessionalExperience';
        isFeatured?: boolean | null;
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          domain?: string | null;
          logoLink?: string | null;
        };
        endAt?: { __typename?: 'MonthYear'; year: number } | null;
      }> | null;
      companiesAdmitted?: Array<{
        __typename?: 'Company';
        id?: string | null;
        name: string;
        domain?: string | null;
        logoLink?: string | null;
      }> | null;
      coachingTimeSummary?: {
        __typename?: 'CoachingTimeSummary';
        availableTime: number;
        hasUnlimitedPackage: boolean;
        cycles?: Array<{
          __typename?: 'SubscriptionCycle';
          timeInMinute: number;
          start?: number | null;
          end?: number | null;
        }> | null;
      } | null;
      mostRecentOrder?: {
        __typename?: 'Order';
        id: string;
        hourlyOrder?: {
          __typename?: 'HourlyOrder';
          timeInMinute: number;
        } | null;
      } | null;
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
        defaultAvailability?: {
          __typename?: 'DefaultAvailability';
          totalInMinute: number;
        } | null;
      } | null;
    };
    subCategories?: Array<{ __typename?: 'SubCategory'; id: string }> | null;
    prices?: Array<{
      __typename?: 'OfferingPackagePrice';
      sku?: string | null;
      price: number;
      tier?: Types.SkuTier | null;
      description?: string | null;
      numberPurchased: number;
      freeLelandPlusPeriod?: {
        __typename?: 'TimePeriod';
        amount: number;
        unit: Types.TimeUnit;
      } | null;
      packageCoachingTime?: {
        __typename?: 'PackageCoachingTime';
        exactTimeInMinute?: number | null;
        estimate?: {
          __typename?: 'IntRange';
          start?: number | null;
          end?: number | null;
        } | null;
      } | null;
    }> | null;
  } | null;
};

export const ApplicantPlanPageOfferingPackageFragmentDoc = gql`
  fragment ApplicantPlanPage_OfferingPackage on OfferingPackage {
    ...OfferingPackagePage_OfferingPackage
  }
  ${OfferingPackagePageOfferingPackageFragmentDoc}
`;
export const ApplicantPlanPageOfferingPackageBySlugDocument = gql`
  query ApplicantPlanPage_OfferingPackageBySlug(
    $slug: String!
    $coach: String!
    $categoryUrn: CategoryUrn!
    $visibleTierOnly: Boolean = true
    $tier: SkuTier
  ) {
    offeringPackageBySlug(
      coach: $coach
      slug: $slug
      visibleTierOnly: $visibleTierOnly
      tier: $tier
    ) {
      ...ApplicantPlanPage_OfferingPackage
    }
  }
  ${ApplicantPlanPageOfferingPackageFragmentDoc}
`;

/**
 * __useApplicantPlanPageOfferingPackageBySlugQuery__
 *
 * To run a query within a React component, call `useApplicantPlanPageOfferingPackageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicantPlanPageOfferingPackageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicantPlanPageOfferingPackageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      coach: // value for 'coach'
 *      categoryUrn: // value for 'categoryUrn'
 *      visibleTierOnly: // value for 'visibleTierOnly'
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useApplicantPlanPageOfferingPackageBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApplicantPlanPageOfferingPackageBySlugQuery,
    ApplicantPlanPageOfferingPackageBySlugQueryVariables
  > &
    (
      | {
          variables: ApplicantPlanPageOfferingPackageBySlugQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ApplicantPlanPageOfferingPackageBySlugQuery,
    ApplicantPlanPageOfferingPackageBySlugQueryVariables
  >(ApplicantPlanPageOfferingPackageBySlugDocument, options);
}
export function useApplicantPlanPageOfferingPackageBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicantPlanPageOfferingPackageBySlugQuery,
    ApplicantPlanPageOfferingPackageBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ApplicantPlanPageOfferingPackageBySlugQuery,
    ApplicantPlanPageOfferingPackageBySlugQueryVariables
  >(ApplicantPlanPageOfferingPackageBySlugDocument, options);
}
export function useApplicantPlanPageOfferingPackageBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApplicantPlanPageOfferingPackageBySlugQuery,
    ApplicantPlanPageOfferingPackageBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ApplicantPlanPageOfferingPackageBySlugQuery,
    ApplicantPlanPageOfferingPackageBySlugQueryVariables
  >(ApplicantPlanPageOfferingPackageBySlugDocument, options);
}
export type ApplicantPlanPageOfferingPackageBySlugQueryHookResult = ReturnType<
  typeof useApplicantPlanPageOfferingPackageBySlugQuery
>;
export type ApplicantPlanPageOfferingPackageBySlugLazyQueryHookResult =
  ReturnType<typeof useApplicantPlanPageOfferingPackageBySlugLazyQuery>;
export type ApplicantPlanPageOfferingPackageBySlugSuspenseQueryHookResult =
  ReturnType<typeof useApplicantPlanPageOfferingPackageBySlugSuspenseQuery>;
export type ApplicantPlanPageOfferingPackageBySlugQueryResult =
  Apollo.QueryResult<
    ApplicantPlanPageOfferingPackageBySlugQuery,
    ApplicantPlanPageOfferingPackageBySlugQueryVariables
  >;
